import saveAs from "file-saver";
import { searchTableColumns } from "../config/data";
import { readLeadList } from "../lib/readLeadList";
import { LeadsFile } from "../router/ImportHistory";
import Papa from "papaparse";
import * as XLSX from "xlsx";

export const handleExport = async (
    record: LeadsFile | null, 
    setExportModalLoading:(value: boolean)=>void,
    exportInMultipleRows:boolean,
    exportKeepCompanyData:boolean,
    setLeadToExport: (value: LeadsFile | null)=>void,
    setExportModalVisible:(value:boolean)=>void,
    setExportFormat: (value:'xlsx' | 'csv' | undefined)=>void,
    localData?: any[],
) => {
    if(!record) return
    setExportModalLoading(true)
    const results = localData ? localData : await readLeadList(record.path);
    
    const leads: any[] = [];

    results.forEach((result: any) => {
      leads.push(result);
    });

    let csvRows: string[] = [];
    const exportColumns = searchTableColumns.filter(col=>(col.dataIndex !== 'dados_empresa'))
    const headerRow = exportColumns.map((col) => `"${col.title}"`);
    csvRows.push(headerRow.join(","));
    for (const item of leads) {
      const row = exportColumns.map((col) => {
        const value =
          item[col.dataIndex] !== undefined ? String(item[col.dataIndex]) : "";
        const escapedValue = value.replace(/"/g, '""');
        return `"${escapedValue}"`;
      });
      csvRows.push(row.join(","));
    }
    let csvData = csvRows.join("\n");
    let blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });

    const text = await new Response(blob).text()

    const parsed = Papa.parse<Record<string, string>>(text, {
      header: true,
      skipEmptyLines: true,
      dynamicTyping: false
    });
  
    if (parsed.errors.length) {
      console.error('Erros no parsing:', parsed.errors);
    } else if (exportInMultipleRows) {
        csvRows = []
        csvRows.push(headerRow.join(","))

      leads.forEach(company => {
        const companyRow = exportColumns
          .map(col => {
            const v = company[col.dataIndex] ?? "";
            return `"${String(v).replace(/"/g, '""')}"`;
          })
          .join(',');
        if(exportKeepCompanyData) csvRows.push(companyRow);
        const raw = company['dados_pessoas'] ?? "[]";
        let employees: any[];
        try {
          employees = JSON.parse(raw);
        } catch {
          employees = [];
        }
        
        employees.forEach((emp: any) => {
          const empRow = exportColumns
            .map(col => {
              if (col.title === 'Pessoas') {
                console.log(emp);
                
                return `"${JSON.stringify({nome: emp.nome,email:emp.email,linkedin_url:emp.linkedin_url || emp.linkedin,titulo:emp.titulo}).replace(/"/g, '""')}"`;
              }
              const v = company[col.dataIndex] ?? "";
              return `"${String(v).replace(/"/g, '""')}"`;
            })
            .join(',');
          csvRows.push(empRow);
        });
      });
      csvData = csvRows.join('\n');
      blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
    } else {
      leads.forEach(lead => {
        let employees: any[] = [];
        try {
          employees = JSON.parse(lead['dados_pessoas'] ?? '[]');
        } catch {
          employees = [];
        }
        
        const simplified = employees.map(emp => ({
          nome: emp.nome,
          email: emp.email,
          linkedin_url: emp.linkedin_url,
          titulo: emp.titulo
        }));
        const jsonString = JSON.stringify(simplified);
        lead['dados_pessoas'] = jsonString;
      });
      const newCsvRows = [ headerRow.join(',') ];
      for (const item of leads) {
        const row = exportColumns.map(col => {
          const v = item[col.dataIndex] ?? "";
          return `"${String(v).replace(/"/g, '""')}"`;
        });
        newCsvRows.push(row.join(','));
      }
      csvData = newCsvRows.join('\n');
      blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
    }
    saveAs(blob, `${record.id}.csv`);
    setLeadToExport(null)
    setExportModalVisible(false)
    setExportModalLoading(false)
    setExportFormat(undefined)
  };

    export const handleExcel = async (
        record: LeadsFile | null, 
        setExportModalLoading:(value: boolean)=>void,
        exportInMultipleRows:boolean,
        exportKeepCompanyData:boolean,
        setLeadToExport: (value: LeadsFile | null)=>void,
        setExportModalVisible:(value:boolean)=>void,
        setExportFormat: (value:'xlsx' | 'csv' | undefined)=>void,
        localData?: any[],
    ) => {
      if (!record) return;
      setExportModalLoading(true);
    
      const results = localData ? localData : await readLeadList(record.path);
      const leads: any[] = [];
      results.forEach(r => leads.push(r));
  
      const exportColumns = searchTableColumns.filter(col => col.dataIndex !== 'dados_empresa');
  
      const rows: any[][] = [];
      const headerRow = exportColumns.map(col => col.title);
      rows.push(headerRow);
  
      if (!exportInMultipleRows) {
        leads.forEach(item => {
          const row = exportColumns.map(col => {
            if (col.title === 'Pessoas') {
              let employees: any[] = [];
              try {
                employees = JSON.parse(item['dados_pessoas'] ?? '[]');
              } catch {
                employees = [];
              }
              const arr = employees.map(emp => ({
                nome:     emp.nome,
                email:    emp.email,
                linkedin_url: emp.linkedin_url,
                titulo:   emp.titulo
              }));
              return JSON.stringify(arr);
            }
            const v = item[col.dataIndex];
            return v !== undefined ? String(v) : '';
          });
          rows.push(row);
        });
      }
       else {
        if (exportKeepCompanyData) {
          leads.forEach(company => {
            const companyRow = exportColumns.map(col => {
              const v = company[col.dataIndex];
              return v !== undefined ? String(v) : '';
            });
            rows.push(companyRow);
            let employees: any[] = [];
            try {
              const raw = company['dados_pessoas'] ?? '[]';
              employees = JSON.parse(raw);
            } catch {
              employees = [];
            }
            employees.forEach(emp => {
              const empRow = exportColumns.map(col => {
                if (col.dataIndex === 'Pessoas' || col.title === 'Pessoas') {
                  return `"${JSON.stringify({nome: emp.nome,email:emp.email,linkedin_url:emp.linkedin_url,titulo:emp.titulo})}"`;
                }
                const v = company[col.dataIndex];
                return v !== undefined ? String(v) : '';
              });
              rows.push(empRow);
            });
          });
        } else {
          leads.forEach(company => {
            let employees: any[] = [];
            try {
              const raw = company['dados_pessoas'] ?? '[]';
              employees = JSON.parse(raw);
            } catch {
              employees = [];
            }     
            employees.forEach(emp => {
              const empRow = exportColumns.map(col => {
                if (col.dataIndex === 'Pessoas' || col.title === 'Pessoas') {
                  return `"${JSON.stringify({nome: emp.nome,email:emp.email,linkedin_url:emp.linkedin_url,titulo:emp.titulo})}"`;
                }
                const v = company[col.dataIndex];
                return v !== undefined ? String(v) : '';
              });
              rows.push(empRow);
            });
          });
        }
      }
      const worksheet = XLSX.utils.aoa_to_sheet(rows);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'export');
      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(blob, `${record.id}.xlsx`);
      setLeadToExport(null);
      setExportModalVisible(false);
      setExportModalLoading(false);
      setExportFormat(undefined)
    };